import CompanyFundamentalsSvg from "@/assets/svg/icon-for-filters/company-fundamentals.svg";
import CompanySizeSvg from "@/assets/svg/icon-for-filters/company-size.svg";
import FundingHistory from "@/assets/svg/icon-for-filters/funding-history.svg";
import OperatingModelSvg from "@/assets/svg/icon-for-filters/operating-model.svg";
import OverviewSvg from "@/assets/svg/icon-for-filters/overview.svg";

export function mockDataPanels() {
  return [
    { id: "Overview", title: "Overview", icon: OverviewSvg },
    { id: "Funding History", title: "Funding History", icon: FundingHistory },
    { id: "Company Size", title: "Company Size", icon: CompanySizeSvg },
    {
      id: "Operating Model",
      title: "Operating Model",
      icon: OperatingModelSvg,
    },
    {
      id: "Company Fundamentals",
      title: "Company Fundamentals",
      icon: CompanyFundamentalsSvg,
    },
  ];
}

export const mockDataCompaniesFilters = ({ filtersList }) => {
  const finder = (id) => filtersList.find((el) => el?.name === id);
  return {
    Overview: {
      templateRows: "repeat(2,1fr)",
      data: [
        // { id: 'Headquarters', isInput: true, data: finder('Headquarters') },
        {
          id: "Accelerator",
          isInput: false,
          data: finder("Accelerator"),
          scrollItemCount: 5,
          heightMob: "100px",
        },
        {
          id: "Main product(s)",
          isInput: true,
          data: finder("Main product(s)"),
          scrollItemCount: 5,
        },
        {
          id: "Technology Used / Offered",
          isInput: true,
          data: finder("Technology Used / Offered"),
          scrollItemCount: 5,
        },
        {
          id: "Sector / Industry Tags",
          isInput: true,
          data: finder("Sector / Industry Tags"),
          scrollItemCount: 5,
        },
        // {
        //   id: "Legal Domicile",
        //   data: finder("Legal Domicile"),
        //   scrollItemCount: 7,
        // },
        {
          id: "Investors",
          isInput: true,
          data: finder("Investors"),
          scrollItemCount: 5,
        },
      ],
    },
    "Funding History": {
      templateRows: "108px 1fr 108px",
      data: [
        {
          id: "Last Valuation ($)",
          data: finder("Last Valuation ($)"),
        },
        {
          id: "Amount Raised in Round ($)",
          data: finder("Amount Raised in Round ($)"),
        },
        {
          id: "Total Raised to Date ($)",
          data: finder("Total Raised to Date ($)"),
        },
        {
          id: "Sector Funding Climate",
          data: finder("Sector Funding Climate"),
          scrollItemCount: 5,
        },
        {
          id: "Next Fundraising Process",
          data: finder("Next Fundraising Process"),
          scrollItemCount: 5,
        },
        {
          id: "Investment Stage",
          data: finder("Investment Stage"),
          scrollItemCount: 5,
        },
        {
          id: "Last Round Year",
          data: finder("Last Round Year"),
        },
      ],
    },
    "Company Size": {
      templateRows: "auto",
      data: [
        {
          id: "Employee Count",
          data: finder("Employee Count"),
        },
        {
          id: "Year Founded",
          data: finder("Year Founded"),
        },
      ],
    },
    "Operating Model": {
      templateRows: "auto",
      data: [
        {
          id: "Model Type(s)",
          data: finder("Model Type(s)"),
          scrollItemCount: 15,
        },
        {
          id: "Revenue Type(s)",
          data: finder("Revenue Type(s)"),
          scrollItemCount: 15,
        },
        {
          id: "Customer Type(s)",
          data: finder("Customer Type(s)"),
          scrollItemCount: 15,
        },
      ],
    },
    "Company Fundamentals": {
      templateRows: "repeat(3,auto)",
      data: [
        {
          id: "aV Average Growth Score",
          data: finder("aV Average Growth Score"),
        },
        {
          id: "aV Average Risk Score",
          data: finder("aV Average Risk Score"),
        },
        {
          id: "Profitability Relative to Peers",
          data: finder("Profitability Relative to Peers"),
        },
        {
          id: "Company Profitability",
          data: finder("Company Profitability"),
        },
        {
          id: "Industry Economics",
          data: finder("Industry Economics"),
        },
        { id: "Cash Runway", data: finder("Cash Runway") },
      ],
    },
  };
};
